export const AdvancedSearchGetters = {
  PermPlacementSearchFields: 'AdvancedSearchGetters.PermPlacementSearchFields',
  AssignmentSearchFields: 'AdvancedSearchGetters.AssignmentSearchFields',
  ExpenseSearchFields: 'AdvancedSearchGetters.ExpenseSearchFields',
  TimeSheetSearchFields: 'AdvancedSearchGetters.TimeSheetSearchFields',
  BranchNames: 'AdvancedSearchFields.BranchNames',
  Divisions: 'AdvancedSearchFields.Divisions',
  Departments: 'AvancedSearchFields.Departments',
  AdvancedSearchParams: 'AvancedSearchFields.AdvancedSearchParams',
  SearchResultsIsLoading: 'AdvancedSearchGetters.SearchResultsIsLoading',
  SearchResults: 'AdvancedSearchGetters.SearchResults',
  FilterFields: 'AdvancedSearchGetters.FilterFields',
  EntityList: 'AdvancedSearchGetters.EntityList',
  TableStatuses: 'AdvancedSearchGetters.TableStatuses',
  SearchResultsOffset: 'AdvancedSearchGetters.SearchResultsOffset',
  SearchResultsPerPage: 'AdvancedSearchGetters.SearchResultsPerPage',
  SearchResultsRecordCount: 'AdvancedSearchGetters.SearchResultsRecordCount',
  SearchResultsSortField: 'AdvancedSearchGetters.SearchResultsSortField',
  SearchResultsSortDirection: 'AdvancedSearchGetters.SearchResultsSortDirection',
  SortableFields: 'AdvancedSearchGetters.SortableFields',
  Rebates: 'AdvancedSearchGetters.Rebates',
  SelectedSearchResults: 'AdvancedSearchGetters.SelectedSearchResults',
  IsAllSelected: 'AdvancedSearchGetters.IsAllSelected',
  DefaultUIFields: 'AdvancedSearchGetters.DefaultUIFields',
  DefaultResultFields: 'AdvancedSearchGetters.DefaultResultFields',
  BatchPdfIsLoading: 'AdvancedSearchGetters.BatchPdfIsLoading',
  PermissionsTableMap: 'AdvancedSearchGetters.PermissionsTableMap'
};

export const AdvancedSearchActions = {
  GetAdvancedSearchFields: 'AdvancedSearchActions.GetAdvancedSearchFields',
  SetSearchFilterField: 'AdvancedSearchActions.SetSearchFilterField',
  ClearSearchFilterField: 'AdvancedSearchActions.ClearSearchFilterField',
  SetSearchTableOrField: 'AdvancedSearchActions.SetSearchTableOrField',
  ClearSearchTableOrField: 'AdvancedSearchActions.ClearSearchTableOrField',
  SetSearchFilterValue: 'AdvancedSearchActions.SetSearchFilterValue',
  DoAdvancedSearch: 'AdvancedSearchActions.DoAdvancedSearch',
  ShowResultDetails: 'AdvancedSearchActions.ShowResultDetails',
  RetrieveSearchResultsRecordCount: 'AdvancedSearchActions.RetrieveSearchResultsRecordCount',
  SetSearchPaginationParameters: 'AdvancedSearchActions.SetSearchPaginationParameters',
  DownloadSearchResultsAsExcel: 'AdvancedSearchActions.DownloadSearchResultsAsExcel',
  SetAdvancedSearchSortOrder: 'AdvancedSearchActions.SetAdvancedSearchSortOrder',
  ToggleSelectSearchResult: 'AdvancedSearchActions.ToggleSelectSearchResult',
  DoBatchAction: 'AdvancedSearchActions.DoBatchAction',
  SelectDeselectAllResults: 'AdvancedSearchActions.SelectDeselectAllResult',
  SetDefaultSearchFields: 'AdvancedSearchActions.SetDefaultSearchFields',
  SetBatchPdfLoading: 'AdvancedSearchActions.SetBatchPdfLoading'
};

export const AdvancedSearchMutations = {
  GetAdvancedSearchFields: 'AdvancedSearchMutations.GetAdvancedSearchField',
  SetSearchFilterField: 'AdvancedSearchMutations.SetSearchFilterField',
  ClearSearchFilterField: 'AdvancedSearchMutations.ClearSearchFilterField',
  SetSearchTableOrField: 'AdvancedSearchMutations.SetSearchTableOrField',
  ClearSearchTableOrField: 'AdvancedSearchMutations.ClearSearchTableOrField',
  SetSearchFilterValue: 'AdvancedSearchMutations.SetSearchFilterValue',
  SetAdvancedSearchResults: 'AdvancedSearchMutations.SetAdvancedSearchResults',
  SetSearchResultsIsLoading: 'AdvancedSearchMutations.SetSearchResultsIsLoading',
  SetSearchResultsRecordCount: 'AdvancedSearchMutations.SetSearchResultsRecordCount',
  SetSearchPaginationParameters: 'AdvancedSearchMutations.SetSearchPaginationParameters',
  SetAdvancedSearchSortOrder: 'AdvancedSearchMutations.SetAdvancedSearchSortOrder',
  ResetAdvancedSearchPaginationOffset:
    'AdvancedSearchMutations.ResetAdvancedSearchPaginationOffset',
  UpdateSelectedSearchResults: 'AdvancedSearchMutations.UpdateSelectedSearchResults',
  SelectDeselectResults: 'AdvancedSearchMutations.SelectDeselectResults',
  ClearAllSelected: 'AdvancedSearchMutations.ClearAllSelected',
  SetDefaultSearchFields: 'AdvancedSearchMutations.SetDefaultSearchFields',
  SetBatchPdfLoading: 'AdvancedSearchMutations.SetBatchPdfLoading'
};
